import React, { Component } from 'react';
import { ButtonToolbar, Button, Form, FormGroup, Checkbox } from 'react-bootstrap';
import { HandleMessage } from '../../HandleMessage';

export class LineCaptionDataIdentifier extends Component {
    constructor(props) {
        super(props);

        let lineCaptionConfiguration = {
            show: false,
            id: props.selectedData || null,
            useLineColorAsCodeBackground: false,
        };

        try {
            const parsedConfig = JSON.parse(props.configuration);
            lineCaptionConfiguration = Object.assign(lineCaptionConfiguration, parsedConfig);
        } catch (error) { }

        this.state = {
            selectedData: props.selectedData,
            table: {
                data: [],
                loading: true,
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
            },
            form: {
                show: lineCaptionConfiguration.show,
                id: lineCaptionConfiguration.id,
                useLineColorAsCodeBackground: lineCaptionConfiguration.useLineColorAsCodeBackground,
            },
            actions: {
                isLoading: true,
            }
        };
    }

    // ---------------------------

    successCallback(result) {
        const { table, actions, form } = this.state;
        const config = result && result.configuration ? JSON.parse(result.configuration) : {};

        actions.isLoading = false;
        table.data = result;

        form.id = result.dataIdentifyer || form.id;
        form.useLineColorAsCodeBackground = config.useLineColorAsCodeBackground !== undefined ? config.useLineColorAsCodeBackground : form.useLineColorAsCodeBackground;

        this.setState({
            table,
            actions,
            form
        });
    }

    errorCallback(message) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.data = [];

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onSelectData(selectedData) {
        const form = this.state;
        form.id = selectedData.value;

        this.setState({
            form,
            selectedData
        });
    }

    onChangeCheckboxValue(target) {
        const { form } = this.state;

        form[target] = !form[target];

        this.setState({
            form: form
        });
    }

    onChangeValue(selectedData, target) {
        const { form } = this.state;

        if (selectedData) {
            form[target] = selectedData.value;
        } else {
            form[target] = null;
        }

        this.setState({
            form: form
        });
    }

    onFinishSelectData() {
        const { form } = this.state;

        const configuration = {
            useLineColorAsCodeBackground: form.useLineColorAsCodeBackground
        };

        // Trigger save actions
        this.props.onConfigureData(JSON.stringify(configuration), true);

        this.setState({
            selectedData: null,
            form: {
                show: false,
                id: null,
                useLineColorAsCodeBackground: false
            },
            styles: {},
        });
    }

    onCancelSelectData() {
        this.setState({
            form: {
                show: false,
                id: 0,
                useLineColorAsCodeBackground: false
            }
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // -----------------------

    render() {
        const { form, message } = this.state;

        return (
            <div>
                <Form>
                    <FormGroup>
                        <Checkbox checked={form.useLineColorAsCodeBackground}
                            onChange={() => this.onChangeCheckboxValue("useLineColorAsCodeBackground")}>
                            Utilizar cor da linha como fundo do código
                        </Checkbox>
                    </FormGroup>
                </Form>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.onFinishSelectData()}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>

                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={this.onExitMessage}
                />
            </div>
        );
    }
}
